export const menuDynamycModal = [
	{
		title: 'Configurações',
		data: [['Gerais', 'general', true]]
	},
	{
		title: 'Permissões',
		data: [
			['Empreendimentos', 'enterprises', false],
			['Customizadas', 'customized', false],
			['Marketing', 'marketing', false],
			['Usuários', 'users', false],
			['Vendas', 'sales', false],
			['Produtos', 'products', false],
			['Comunicação', 'communication', false],
			['Clube de Pontos', 'points_club', false],
		]
	}
]

export const defaultMenuModal = (menuList) => {
	let list = []
	menuList.forEach((section, index) => {
		const sections = { title: section.title, data: [] }
		section.data.forEach((item) => {
			sections.data.push({
				id: index,
				title: item[0],
				value: item[1],
				active: item[2]
			})
		})
		list.push(sections)
	})
	return list
}
